import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Interweave } from 'interweave';

const propTypes = {
  content: PropTypes.string.isRequired,
};

const ContractTextContainer = styled.div`
  font-size: 1rem;
  text-align: justify;
  word-wrap: break-word;
`;

const ContractText = ({ content }) => (
  <ContractTextContainer id="terms-and-conditions-phrase">
    <Interweave content={content} />
  </ContractTextContainer>
);

ContractText.propTypes = propTypes;

export default ContractText;
